import React, {
    useEffect,
    useState
} from "react";

import axios from "axios";

import {
    Award,
    ArrowRight
} from "lucide-react";

import {
    useNavigate
} from "react-router-dom";

import "./VaultProgressCard.css";


const defaultSummary = {

    unlocked: 0,

    claimed: 0,

    totalXP: 0,

    currentLevel: 1,

    currentStreak: 0,

    totalAssessments: 0,

    courseProgress: 0

};


const VaultProgressCard = () => {

    const navigate =
        useNavigate();


    const email =
        localStorage.getItem(
            "user_email"
        );


    const [
        summary,
        setSummary
    ] = useState(
        defaultSummary
    );


    const [
        loading,
        setLoading
    ] = useState(true);


    /* =====================================
       LOAD VAULT DATA
    ===================================== */

    useEffect(() => {

        if (email) {

            loadVault();

        }

        else {

            setLoading(false);

        }

    }, [email]);


    const loadVault = async () => {

        try {

            /* =================================
               PROFILE + COURSE API
            ================================= */

            const [

                profileRes,

                courseRes

            ] = await Promise.all([

                axios.get(

                    `/api/ignite/profile/${email}`

                ),

                axios.get(

                    `/api/ignite/course/status/${email}`

                )

            ]);


            /* =================================
               PROFILE SUMMARY
            ================================= */

            const profileSummary =
                profileRes.data?.summary || {};


            /* =================================
               COURSE STATUS
            ================================= */

            const courses =
                courseRes.data?.courses || {};


            /* =================================
               CALCULATE COURSE PROGRESS

               Same logic as VaultHero
            ================================= */

            const completedCourses = [

                courses
                    .neuroPerformanceFoundational,

                courses
                    .eyeHealthAthleticEdition,

                courses
                    .eyeHealthDetailed

            ].filter(Boolean).length;


            const totalCourses = 3;


            const courseProgress =
                Math.round(

                    (
                        completedCourses /
                        totalCourses
                    ) * 100

                );


            /* =================================
               SET FINAL SUMMARY
            ================================= */

            setSummary({

                ...defaultSummary,

                ...profileSummary,

                /*
                 * Course progress comes
                 * from course status API
                 */

                courseProgress:

                    courseProgress

            });

        }

        catch (err) {

            console.error(

                "Vault Error:",

                err

            );


            setSummary(

                defaultSummary

            );

        }

        finally {

            setLoading(false);

        }

    };


    /* =====================================
       LOADING
    ===================================== */

    if (loading) {

        return (

            <div className="vault-progress-card">

                Loading...

            </div>

        );

    }


    /* =====================================
       UI
    ===================================== */

    return (

        <div className="vault-progress-card">


            {/* =================================
                HEADER
            ================================= */}

            <div className="vault-header">

                <div>

                    <h3>

                        Vault Progress

                    </h3>

                    <p>

                        Unlock rewards and earn XP.

                    </p>

                </div>


                <Award size={30} />

            </div>


            {/* =================================
                PROGRESS BAR
            ================================= */}

            <div className="vault-progress">

                <div className="vault-bar">

                    <div

                        className="vault-fill"

                        style={{

                            width:
                                `${Math.min(
                                    Math.max(
                                        summary.courseProgress,
                                        0
                                    ),
                                    100
                                )}%`

                        }}

                    />

                </div>

            </div>


            {/* =================================
                STATS
            ================================= */}

            <div className="vault-grid">


                {/* UNLOCKED */}

                <div>

                    <span>

                        Unlocked

                    </span>

                    <strong>

                        {summary.unlocked}

                    </strong>

                </div>


                {/* CLAIMED */}

                <div>

                    <span>

                        Claimed

                    </span>

                    <strong>

                        {summary.claimed}

                    </strong>

                </div>


                {/* TOTAL XP */}

                <div>

                    <span>

                        Total XP

                    </span>

                    <strong>

                        {summary.totalXP}

                    </strong>

                </div>


                {/* COURSE PROGRESS */}

                <div>

                    <span>

                        Course Progress

                    </span>

                    <strong>

                        {summary.courseProgress}%

                    </strong>

                </div>


            </div>


            {/* =================================
                OPEN VAULT
            ================================= */}

            <button

                className="vault-btn"

                onClick={() =>

                    navigate(
                        "/ignite/vault"
                    )

                }

            >

                Open Vault

                <ArrowRight size={18} />

            </button>


        </div>

    );

};


export default VaultProgressCard;